import React, { useState, useEffect } from "react";
import { Row, Col, Spinner } from "react-bootstrap";
import { Form, FormGroup, Label, Input } from "reactstrap";
import { validate } from "helpers/validations";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
// import { toast } from "react-hot-toast";
import {
  uploadFile,
  postCollection,
  getCollectionBytecode,
  getCategories,
  postNewCollection,
  getNewCollectionByIdStart,
  putNewCollectionByIdStart,
} from "store/actions";

import useMetaMask from "hooks/metsmask";
import toastr from "toastr";
import { BLOCKCHAIN_ENUM } from "helpers/constants";
import Web3Intraction from "utils/web3Intraction";
export default function CreateCollection() {
  const [menu, menuopen] = useOutletContext();
  useEffect(() => {
    menu(false)
  }, [menu])
  let wallAddress = localStorage.getItem("walletAddress");
  const params = useParams()
  const dispatch = useDispatch();
  let navigate = useNavigate();
  let hooks = useMetaMask();
  let { email } = useSelector((state) => state?.Login.user);
  let { loading } = useSelector((state) => state?.collections);
  const selector = useSelector((state) => state);
  const [internalLoading, setinternalLoading] = useState(false);
  const [fieldsError, setfieldsError] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false)
  const [categoryId, setCategoryId] = useState()
  const [image, setImage] = useState()
  const [descLen, setDescLen] = useState(300)
  const [nameLen, setNameLen] = useState(50)
  const { id } = useParams();
  const [fields, setFields] = useState({
    name: "",
    description: "",
    image: null,
    imagePreview: null,
    // blockchain: "",
    email: "",
    category: ""
    // creatorEarning: "",
    // creatorAddress: "",
  });

  useEffect(() => {
    if (id) {
      setIsUpdate(true)
      if (id) {


        const callback = (res) => {
          const { message, status } = res;
          if (status === "success") {
            setFields({
              ...fields,
              name: res.data.name,
              description: res.data.description,
              email: res.data.email.email,
              image: res.data.image._id,
              imagePreview: res.data.image.link,
              // category: res.data.category[0]?.image
              // imageRaw: selector?.collections.collections[0].image.link,
              // name: selector?.collections.collections[0].name,
              // name: selector?.collections.collections[0].name,
              // userName: this.props.item.userName
            });


          } else {
            toastr.error(message);
          }
        };

        // dispatch(VerifyUserOtp(OtpDaTa, callback));

        dispatch(getNewCollectionByIdStart(id, callback))
      }
    }
  }, [])

  const onChangeHandler = (name) => (evt) => {
    const { value } = evt.target;
    setfieldsError((prev) =>
      value !== "" || undefined || null
        ? { ...prev, [name + "Error"]: false, [name]: value }
        : { ...prev, [name + "Error"]: true, [name]: value }
    );;
    setFields((prevState) => ({ ...prevState, [name]: value }));

  };


  const uploadFileSuccess = (name) => async (response) => {

    const { _id } = await response?.data;
    onChangeHandler(name)({ target: { value: _id } });
  };

  const handleImageChange = (name) => (evt) => {
    const image = evt.target.files;
    const ext = image[0].name.split(".").pop();
    if (
      ext !== "png" &&
      ext !== "jpg" &&
      ext !== "jpeg" &&
      ext !== "gif"
    ) {
      toastr.error("Only .png,.jpg,.jpeg, gif extension allow!!");
      return;
    }
    if (image[0] && image[0].size >= 1e7) {
      toastr.error("Please upload a file smaller than 1 MB");
      return false;
    }

    if (image && image[0]) {
      dispatch(uploadFile({ image: image[0] }, uploadFileSuccess(name)));
      setFields((prevState) => ({
        ...prevState,
        imagePreview: URL.createObjectURL(image[0]),
        imageRaw: image[0],
        image: image[0],
      }));

      setFields((prevState) => ({
        ...prevState,
        email: email
      }));
    }
  };

  const onSubmit = (evt) => {
    evt.preventDefault();
    // if (!id) {
      let data2 = validate(fields);
      setfieldsError(data2);
      if (fields?.image === null) {
        return toastr.error("Image is required");
      }
      if (fields?.name === '') {
        return toastr.error("Collection name is required");
      }
      if (fields?.name.length > 50) {
        return toastr.error("Name length should be less than 50 ");
      }
      if (!fields?.description) {
        return toastr.error("Please enter the description");
      }
      if (fields?.description.length > 300) {
        return toastr.error("Description length should be less than 300 ");
      }

      // if (fields?.category === "") {
      //   return toastr.error("Category is required");
      // }
    // }
    if (selector?.collections?.loading) return;
    if (selector?.File?.loading) return;

    // if (!window.ethereum || wallAddress === null) {
    //   setinternalLoading(false);
    //   toastr.error(
    //     "Connect your Metamask wallet to update the collection."
    //   );
    //   return;
    // }

    // if (!fields?.image) {
    //   return toast.error("Logo Image  is required");
    // }
    // if (!fields?.name) {
    //   return toast.error("Name  is required");
    // }
    // if (!fields?.description) {
    //   return toast.error("Description  is required");
    // }
    // if (fields?.creatorEarning < 1) {
    //   return toast.error("Creator Earning Should be 1 or Greater");
    // }

    // const web3intraction = new Web3Intraction(
    //   fields.blockchain,
    //   hooks?.walletType,
    //   selector?.Login?.settings
    // );

    // if (!web3intraction.isNetworkServiceWorking()) {
    //   setinternalLoading(false);
    //   return toast.error("Service Not Available!");
    // }
    setinternalLoading(true);
    // const getCollectionData = async (response) => {
    //   if (response.status === "failure") {
    //     toast.error(response.message);
    //   } else {
    //     toast.success(response.message);
    //   }
    try {
      if (id) {
        dispatch(
          putNewCollectionByIdStart(
            {
              ...fields,
              id: id
              // transactionHash: txHash,
              // contractAddress: receipt.contractAddress,
              // contractAbi: response?.data?.abi,
              // contract_uri: response?.data?.contract_uri,
              // type: fields?.blockchain,
            },
            (response) => {
              if (response.status) {
                toastr.success("Collection has been updated successfully");
                navigate("/profile/collection/created");
              }

            }
          )
        );

      }
      else {
        // const { txHash, receipt } = await web3intraction?.deployContract(
        //   wallAddress,
        //   response
        // );
        dispatch(
          postNewCollection(
            {
              ...fields,
              // transactionHash: txHash,
              // contractAddress: receipt.contractAddress,
              // contractAbi: response?.data?.abi,
              // contract_uri: response?.data?.contract_uri,
              // type: fields?.blockchain,
            },
            (response) => {
              if (response.status) {
                toastr.success("Collection has been created successfully");
                navigate("/profile/collection/created");
              } else {
                toastr.error(response.message);
              }
            }
          )
        );
      }
      setinternalLoading(false);
    } catch (error) {
      console.log("error", error);
      setinternalLoading(false);
    }
  };

  useEffect(() => {
    dispatch(getCategories({ limit: 100, orderBy: "", order: "", page: 1 }));
  }, []);


  useEffect(() => {
    setDescLen(300 - fields?.description?.length)
  }, [fields?.description]);
  useEffect(() => {
    setNameLen(50 - fields?.name?.length)
  }, [fields?.name]);

  useEffect(() => {
    document.querySelectorAll('textarea').forEach((el) => {
      el.style.height = el.setAttribute('style', 'height: ' + el.scrollHeight + 'px');
      el.classList.add('auto');
      el.addEventListener('input', e => {
        el.style.height = 'auto';
        el.style.height = (el.scrollHeight) + 'px';
      })
    })
  }, [])
  const reArtUpload = () => {
    setFields((p)=>({...p, imageRaw:"", imagePreview:""}))
  }
  return (
    <>
      <Row>
        <Col lg={12} className="mb-4">
          <h1><i onClick={menuopen} className="fa-light fa-bars-sort"></i>  {isUpdate ? 'Update Collection Content' : 'Collection Content'} </h1>
        </Col>
        <Col lg={12}>
          <Form onSubmit={onSubmit}>
            <div className={"createCollection uploadFilecrete mb-4" + (fieldsError?.imageError ? ' invalid' : '')}>
              {fields?.imagePreview ? (
                <div className="upload-image text-center">
                  <label htmlFor="inputGroupFile01">
                    <div className="uploadimgnew position-relative ">
                      <img className="img-fluid" src={fields?.imagePreview || "img/upload-img.png"} alt="" />
                      <button type="button" onClick={reArtUpload}  className="upoadDocClose closebtnart">
                                <i class="fa-solid fa-circle-xmark"></i>
                              </button>
                    </div>
                  </label>
                  <input className="previewImageInput" name="image" type="file" id="inputGroupFile01" onChange={handleImageChange("image")} accept="image/*" />
                </div>
              ) : (
                <div className={`upload-btn-wrapper`}>
                  <div className="text-center uploadimgnew">
                    <input name="image" type="file" hidden id="inputGroupFile01" onChange={handleImageChange("image")} accept="image/*" />
                    <div className="label-flex text-center">
                      <Label htmlFor="inputGroupFile01" className="label-style-file"></Label>
                    </div>
                    <Label className="d-grid text-secondary cursor-pointer" for="inputGroupFile01">
                      <i className="fa-sharp fa-light fa-file-arrow-up mb-3"></i>
                      {fields.imageRaw ? fields.imageRaw.name : "UPLOAD FROM YOUR DEVICE"}
                    </Label>
                  </div>
                </div>
              )}
              <p className="mt-3 mb-3 text-center uploadimgText">
                {fields.imageRaw ? 'Create your Digital Artwork collection and select a captivating thumbnail to showcase its uniqueness.' : ' Upload your Collection Image jpg, png, gif & 3D Image file size : 1MB. *'}

              </p>
            </div>
            <div className="createCollection">
              <div className="position-relative mb-3">
                <h2>What kind of item are you making? </h2>
                {/* <div className="line"></div> */}
              </div>
              <FormGroup className="form-group mb-4">
                <Label className="mb-1">Collection Name</Label>
                <div className="position-relative">
                  <Input
                    type="text"
                    name="name"
                    maxLength="50"
                    value={fields?.name}
                    onChange={onChangeHandler("name")}
                    className={'form-control bg-white pe-5' + (fieldsError?.nameError && "invalid" ? ' gender' : '')}
                    // required={fieldsError?.nameError}
                    invalid={fieldsError?.nameError}
                    placeholder="Collection Name"
                  />
                  <div className="addresmsg position-absolute py-3 bottom-0 top-0 my-auto end-0">{nameLen + "/50"}</div>
                </div>
              </FormGroup>
              {/* <FormGroup className="form-group mb-4">
                <label className="mb-1">Select Category</label>
                <ul className="cateList">
                  {selector?.categories?.categories?.map((item) => (
                    <li>
                      <Input type="radio" name="category" id={item._id} key={item._id} onChange={onChangeHandler('category')} value={item._id} invalid={fieldsError?.categoryError} />
                      <label for={item._id}> {item.name}</label>
                    </li>
                  ))}
                </ul>
              </FormGroup> */}
              <FormGroup className="form-group mb-4 discription">
                <Label className="mb-1">Description</Label>

                <div className="position-relative">
                  <Input
                    type="textarea"
                    name="description"
                    maxlength="300"
                    value={fields?.description.replace(/\s+/g, ' ')}
                    onChange={onChangeHandler("description")}
                    className={'form-control pb-4 bg-white' + (fieldsError?.descriptionError && "invalid" ? ' gender' : '')}
                    invalid={fieldsError?.descriptionError}
                    // required={fieldsError?.nameError}
                    placeholder="Define your Collection"
                  />

                  <div className="addresmsg position-absolute bottom-0 end-0">{descLen + "/300"}
                  </div>
                </div>
                <p className="pdecription mt-2">
                  This description will be included a link to this URL on
                  this Collection detail page.
                </p>
              </FormGroup>
              {/* <FormGroup  className="form-group mb-4">
                    <Label className="mb-1">Creator Earnings</Label>
                    <Input
                      type="text"
                      min="1"
                      max="10"
                      name="creatorEarning"
                      value={fields?.creatorEarning}
                      onChange={onChangeHandler("creatorEarning")}
                      className={'form-control bg-white' + (fieldsError?.creatorEarningError && "invalid" ? ' gender':'') }
                    
                      required={fieldsError?.creatorEarningError}
                      placeholder="e.g 2.5%"
                    />
                  </FormGroup> */}
              {/* <FormGroup  className="form-group mb-4">
                    <Label className="mb-1">Creator Address</Label>

                    <Input
                      disabled
                      type="text"
                      name="creatorAddress"
                      value={fields?.creatorAddress}
                      onChange={onChangeHandler("creatorAddress")}
                      className={'form-control bg-white' + (fieldsError?.creatorAddressError && "invalid" ? ' gender':'') }

                    
                      required={fieldsError?.creatorAddressError}
                      placeholder="0xa7b534884c8b40939a5b121ffe1d3d2ef5d6e927"
                    />
                  </FormGroup> */}
              {/* <FormGroup  className="form-group position-relative mb-4">
                    <Label className="mb-1">Blockchain</Label>

                    <Input
                      type="select"
                      name="blockchain"
                      value={fields?.blockchain}
                      onChange={onChangeHandler("blockchain")}
                      className={'form-control bg-white shadow-none' + (fieldsError?.blockchainError && "invalid" ? ' gender':'') }
                       required={fieldsError?.blockchainError}
                    >
                      <option value="">Select Blockchain</option>
                      {BLOCKCHAIN_ENUM.map((item, index) => (
                        <option key={`chain-${index}`} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                    </Input>
                    
                  </FormGroup> */}
              <FormGroup>
                <div className="text-center Done-wrap">

                  <button
                    type={"submit"}
                    className="btn btn-secondary text-white fw-semibold px-5"
                  >{id ? 'Update Collection ' : 'Create Collection'}
                    {loading || internalLoading ? (<Spinner animation="border" size="sm" role="status"></Spinner>) : ('')}
                  </button>

                </div>
              </FormGroup>
            </div>
          </Form>
        </Col>
      </Row>

      {/* <section className="Artistsubmission-main create-nft create-colection" hidden>
        <div className="artist-submission">
          <div className="DigitalArtcollection-head text-center">
            <h2>Create New Collection</h2>
          </div>

          <div className="artist-submission create-nftform create-collectionmain">
            <Form onSubmit={onSubmit}>
              <Row>
                <Col lg={12}>
                  <div className="fileupload-wrap mt-4 create-nft-upload create-collection-up">
                    <Label>Logo image *</Label>

                    {fields?.imagePreview ? (
                      <div className="upload-image text-center">
                        <label htmlFor="inputGroupFile01">
                          <div className="fileContainer sprite">
                            <img
                              className="img-fluid"
                              src={fields?.imagePreview || "img/upload-img.png"}
                              alt=""
                            />
                          </div>
                        </label>
                        <input
                          className="previewImageInput"
                          name="image"
                          type="file"
                          id="inputGroupFile01"
                          onChange={handleImageChange("image")}
                          accept="image/*"
                        />
                      </div>
                    ) : (
                      <div
                        className={`upload-btn-wrapper ${
                          fieldsError?.imageError && "invalid"
                        }`}
                      >
                        <label
                          htmlFor="inputGroupFile01"
                          className="btnwrap"
                          for="inputGroupFile01"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="58"
                            height="50"
                            viewBox="0 0 58 50"
                            fill="#878787"
                          >
                            <path
                              d="M0.833984 7.39375C0.833984 5.52596 1.57596 3.73468 2.89668 2.41396C4.21741 1.09323 6.00869 0.351257 7.87648 0.351257H50.1314C51.9992 0.351257 53.7905 1.09323 55.1112 2.41396C56.432 3.73468 57.1739 5.52596 57.1739 7.39375V42.6062C57.1739 44.474 56.432 46.2653 55.1112 47.586C53.7905 48.9067 51.9992 49.6487 50.1314 49.6487H7.87648C6.00869 49.6487 4.21741 48.9067 2.89668 47.586C1.57596 46.2653 0.833984 44.474 0.833984 42.6062V7.39375ZM4.35523 39.085V42.6062C4.35523 43.5401 4.72622 44.4357 5.38658 45.0961C6.04694 45.7565 6.94258 46.1275 7.87648 46.1275H50.1314C51.0653 46.1275 51.961 45.7565 52.6213 45.0961C53.2817 44.4357 53.6527 43.5401 53.6527 42.6062V30.2819L40.3529 23.426C40.0227 23.2606 39.6488 23.2032 39.2842 23.262C38.9196 23.3207 38.5827 23.4927 38.3212 23.7535L25.2574 36.8173L15.8908 30.5776C15.5527 30.3525 15.147 30.2512 14.7427 30.291C14.3384 30.3308 13.9603 30.5092 13.6724 30.796L4.35523 39.085ZM21.9615 16.1969C21.9615 14.796 21.405 13.4526 20.4144 12.462C19.4239 11.4715 18.0804 10.915 16.6796 10.915C15.2788 10.915 13.9353 11.4715 12.9447 12.462C11.9542 13.4526 11.3977 14.796 11.3977 16.1969C11.3977 17.5977 11.9542 18.9412 12.9447 19.9317C13.9353 20.9223 15.2788 21.4787 16.6796 21.4787C18.0804 21.4787 19.4239 20.9223 20.4144 19.9317C21.405 18.9412 21.9615 17.5977 21.9615 16.1969Z"
                              fill="#878787"
                            />
                          </svg>
                        </label>

                        <input
                          name="image"
                          type="file"
                          id="inputGroupFile01"
                          onChange={handleImageChange("image")}
                          accept="image/*"
                        />
                        <div className="label-flex">
                          <Label
                            htmlFor="inputGroupFile01"
                            className="label-style-file"
                          ></Label>
                          <Label for="inputGroupFile01">
                            {fields.imageRaw
                              ? fields.imageRaw.name
                              : "file Name"}
                          </Label>
                        </div>
                      </div>
                    )}
                    <p className="mt-3 mb-3">
                      Upload your Collection Image jpg, png, or 3D Image file
                      size : 10MB. *
                    </p>
                  </div>
                </Col>

                <Col lg={12} md={12} sm={12}>
                  
                </Col>

                <Col lg={12} md={12} sm={12}>
                  <FormGroup className="position-relative">
                    <Label>Category</Label>

                    <Input
                      type="select"
                      name="category"
                      value={fields?.category}
                      onChange={onChangeHandler("category")}
                      className={` gender ${
                        fieldsError?.categoryError && "invalid"
                      }`}
                      required={fieldsError?.categoryError}
                    >
                      <option>Select Category</option>
                      {selector?.categories?.categories?.map((item) => (
                        <option key={item._id} value={item.name}>
                          {item.name}
                        </option>
                      ))}
                    </Input>

                    <div className="down-arrow">
                      <svg
                        className="iconify iconify--material-symbols"
                        width="32"
                        height="32"
                        preserveAspectRatio="xMidYMid meet"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="currentColor"
                          d="M12 14.975q-.2 0-.387-.075q-.188-.075-.313-.2l-4.6-4.6q-.275-.275-.275-.7q0-.425.275-.7q.275-.275.7-.275q.425 0 .7.275l3.9 3.9l3.9-3.9q.275-.275.7-.275q.425 0 .7.275q.275.275.275.7q0 .425-.275.7l-4.6 4.6q-.15.15-.325.212q-.175.063-.375.063Z"
                        />
                      </svg>
                    </div>
                  </FormGroup>
                </Col>

                <Col lg={12} md={12} sm={12}>
                  
                </Col>

                <Col lg={12} md={12} sm={12}>
                  
                </Col>

                <Col lg={12} md={12} sm={12}>
                  
                </Col>

                <Col lg={12} md={12} sm={12}>
                  
                </Col>
              </Row>

              <div className="text-center Done-wrap">
                {loading || internalLoading ? (
                  <button
                    type={"submit"}
                    className="showmore btn btn-primary Submit-btn"
                  >
                    <Spinner animation="border" role="status"></Spinner>
                  </button>
                ) : (
                  <button
                    type={"submit"}
                    className="showmore btn btn-primary Submit-btn"
                  >
                    Create Collection
                  </button>
                )}
              </div>
            </Form>
          </div>
        </div>
      </section> */}
    </>
  );
}
